import { ArrowsClockwise, WifiSlash } from "@phosphor-icons/react";

export interface SnapshotStaleBannerProps {
  staleSource: string;
  onRetry?: () => void;
  isRetrying?: boolean;
  /** "stale" is a snapshot we have, just not today's. */
  variant?: "stale" | "unavailable";
}

export function SnapshotStaleBanner({
  staleSource,
  onRetry,
  isRetrying = false,
  variant = "stale",
}: SnapshotStaleBannerProps) {
  const heading = variant === "unavailable" ? "Snapshot did not load" : "Snapshot from yesterday";
  return (
    <div className="snap-stale-banner snap-stagger-item" style={{ animationDelay: "120ms" }}>
      <WifiSlash size={22} weight="duotone" />
      <div className="snap-stale-text">
        <div className="snap-stale-h">{isRetrying ? "Checking for updates..." : heading}</div>
        <div className="snap-stale-sub">
          {staleSource}. Refresh shows the latest we've received; new wearable data arrives as your
          provider syncs it.
        </div>
      </div>
      {onRetry && (
        <button
          type="button"
          className="snap-stale-retry"
          onClick={onRetry}
          disabled={isRetrying}
          aria-label={isRetrying ? "Refreshing..." : "Refresh"}
        >
          <ArrowsClockwise
            size={14}
            weight="bold"
            style={isRetrying ? { animation: "snap-spin 0.8s linear infinite" } : undefined}
          />
          {isRetrying ? "Refreshing..." : "Refresh"}
        </button>
      )}
    </div>
  );
}
